import React from "react";
import { logoutUser } from "../../../data/mutations/Auth/logoutUser";
import { useNavigate } from 'react-router-dom';

export const LogOutBtn = () => {
  const navigate = useNavigate()
  return <button onClick={(e) => logoutUser().then( _ => navigate("login"))}>Log Out</button>;
};
